export default {
  benefits: {
    earn_points: 'Gana puntos con cada pedido',
    get_deals: 'Recibe descuentos exclusivos',
    redeem_points: 'Canjea puntos por comida gratis',
  },
};
